/* eslint-disable camelcase */
import { EventActionName } from 'Utils/API/types/omniaPreventController';
export var EventPostType;
(function (EventPostType) {
    EventPostType["CREATE"] = "create";
    EventPostType["UPDATE"] = "update";
})(EventPostType || (EventPostType = {}));
